<template>
  <div class="showImgAndFile">
    <div v-if="list && list.length > 0">
      <div class="image_list">
        <div :key="item.url || item" v-for="item in imgList">
          <EnlargeImg v-if="item" :imgSrc="item" />
        </div>
      </div>
      <div
        class="pdf_list"
        v-for="item in pdfList"
        :key="item.url || item"
        :title="item.name || item"
      >
        <div class="pdf_item mr16" @click="handleDownload(item)">
          <i class="el-icon-document"></i>
          {{ item.name || item }}
        </div>
        <el-button type="text" @click="previewPdf(item)">预览</el-button>
      </div>
      <div
        class="file_item"
        v-for="item in fileList"
        :key="item.url || item"
        :title="item.name || item"
      >
        <i class="el-icon-document"></i>
        <a :href="item.url"> {{ item.name || item }}</a>
      </div>
    </div>
    <div v-else>{{ emptyText }}</div>
    <el-dialog
      close="pdf_dialog"
      width="1000px"
      :title="pdfName"
      :visible.sync="isshow"
      append-to-body
    >
      <PdfPreview v-if="pdfUrl && isshow" :url="pdfUrl" :name="pdfName" />
    </el-dialog>
  </div>
</template>
<script>
import { interfacePrefix } from '@/config'

export default {
  name: 'showImgAndFile',
  props: {
    list: {
      type: [String, Array], // 列表
      default: () => [],
    },
    emptyText: {
      type: String,
      default: '暂无',
    },
  },
  data() {
    return {
      isshow: false,
      pdfUrl: '',
      pdfName: '',
      imgList: [],
      fileList: [],
      pdfList: [],
      imgType:
        '.jpg,.gif,.png,.jpeg,.bmp,.webp,.heic,.JPG,.GIF,.PNG,.JPEG,.BMP,.WEBP,.HEIC',
      pdfType: '.pdf',
    }
  },
  watch: {
    list: {
      handler(val) {
        this.getList(val)
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // pdf预览
    previewPdf(file) {
      this.isshow = true
      this.pdfName = file.name || 'PDF预览'
      this.pdfUrl = file.url || file || ''
    },
    // 判断返回的数据是不是json
    isJSON(str) {
      if (typeof str === 'string') {
        try {
          const obj = JSON.parse(str)
          if (typeof obj === 'object' && obj) {
            return true
          } else {
            return false
          }
        } catch (e) {
          return false
        }
      } else {
        return false
      }
    },
    // 获取图片和文件列表
    getList(allList) {
      if (allList) {
        const list = this.dealFile(allList)
        this.imgList = list.imgList
        this.fileList = list.fileList
        this.pdfList = list.pdfList
      }
    },
    // 获取图片列表,文件列表
    dealFile(data) {
      // 只处理数组和字符串数据
      if (Array.isArray(data)) {
        return this.parseList(data)
      }
      if (typeof data === 'string') {
        // 如果是字符串数据判断是不是JSON字符串
        data = this.isJSON(data) ? JSON.parse(data) : data.split(',')
        return this.parseList(data)
      }
      return { imgList: [], fileList: [], pdfList: [] }
    },
    // 下载图片
    handleDownload(file) {
      if (typeof file === 'string' && file?.indexOf('http') === 0) {
        fetch(file)
          .then((res) => res.blob())
          .then((blob) => {
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = `保单附件${new Date().getTime()}`
            document.body.appendChild(link)
            link.click()
          })
      } else if (!file.name) {
        const url = file.slice(file.indexOf('?') + 1)
        location.href = `${interfacePrefix}/fs/download?${url}`
      } else {
        fetch(file.url)
          .then((res) => res.blob())
          .then((blob) => {
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = file.name
            document.body.appendChild(link)
            link.click()
          })
      }
    },
    // 处理数据  ['xxxxx', 'xxxxx']
    parseList(list) {
      const imgList = []
      const fileList = []
      const pdfList = []
      list.forEach((item) => {
        const path = item.url ? item.url.split('/') : item.split('/')
        const lastItem = path[path.length - 1]
        let suffix = lastItem.split('.')?.pop()
        suffix = suffix.split('?')?.shift()
        if (suffix) {
          if (this.imgType.includes(suffix)) {
            imgList.push(item)
          } else if (this.pdfType.includes(suffix)) {
            pdfList.push(item)
          } else {
            fileList.push({
              ...item,
            })
          }
        }
      })
      return { imgList, fileList, pdfList }
    },
  },
}
</script>
<style lang="scss" scoped>
.image_list {
  display: flex;
  & > div {
    margin-bottom: 10px;
  }
  ::v-deep .imgDiv {
    margin-right: 10px;
  }
}
.pdf_list {
  display: flex;
}
.file_item,
.pdf_item {
  width: 100%;
  color: #276bec;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-height: 27px;
}
</style>
